import React, {useState} from 'react'
import {useParams, useLocation, useNavigate} from 'react-router-dom'
import {BsArrowLeft} from "react-icons/bs";
import Inserts from "./Inserts";
import InsertsParameter from "./InsertsParameter";
import InsertsSpecification from "./InsertsSpecification";
import InsertsSpecificationParameter from "./InsertsSpecificationParameter";


const InsertsPageLayout = () => {
    const {id} = useParams();
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [specificationRowId, setSpecificationRowId] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <>
            <div className="px-4 pt-4 mb-2 sm:px-6 lg:px-8">
                <div className="flex items-center">
                    <button
                        className="mr-3 duration-300 ease-in-out hover:text-blue-900 hover:-translate-x-3"
                        onClick={() => navigate(-1)}
                    >
                        <BsArrowLeft className="w-6 h-6 mr-1 hover:cursor-pointer"/>
                    </button>
                    <h3 className="text-2xl">
                        {location.state.item.article + " - " + location.state.item.supplierName + " - " + location.state.item.productName}
                    </h3>
                </div>
                <div className='grid grid-cols-6 mt-4 gap-x-5'>

                    {/*FURNITURE DEPEND SPECIFICATION LIMIT TABLE*/}
                    <div className="col-span-6 sm:col-span-3">
                        <Inserts
                            consistId={id}
                            selectedRowId={selectedRowId}
                            setSelectedRowId={setSelectedRowId}
                        />
                    </div>

                    {/*FURNITURE MAIN SPECIFICATION TABLE PARAMETER*/}
                    <div className="col-span-6 sm:col-span-3">
                        <InsertsParameter additionalId={selectedRowId}/>
                    </div>

                    {/*FURNITURE DEPEND SPECIFICATION TABLE*/}
                    <div className="col-span-6 sm:col-span-3">
                        <InsertsSpecification
                            setSpecificationRowId={setSpecificationRowId}
                            additionalId={selectedRowId}
                        />
                    </div>

                    {/*FURNITURE DEPEND SPECIFICATION TABLE*/}
                    <div className="col-span-6 sm:col-span-3">
                        <InsertsSpecificationParameter
                            specificationId={specificationRowId}
                        />
                    </div>

                </div>
            </div>
        </>
    )
}

export default InsertsPageLayout;
